module.exports = __webpack_public_path__ + "img/5.2e8e3cc5.jpg";